export enum CoachGender {
    'Male' = 0,
    'Female' = 1,
    'Non Binary' = 2,
    'Intersex' = 3,
    'Rather Not Say' = 4,
    'Other' = 5
}